module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "voice_input"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.recognitionText
    },
    model: {
      value: (_vm.voiceInput.message),
      callback: function($$v) {
        _vm.$set(_vm.voiceInput, "message", $$v)
      },
      expression: "voiceInput.message"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "color": "cyan darken-2"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startInput($event)
      }
    }
  }, [_c('v-icon', [_vm._v("\n      mic\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-984367b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/parts/VoiceInput.vue
// module id = 487
// module chunks = 1